import { render, staticRenderFns } from "./DispositionPdf.vue?vue&type=template&id=2dfdbede"
import script from "./DispositionPdf.vue?vue&type=script&lang=js"
export * from "./DispositionPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports